const QUANTITY_INFO = [
    {
        id: "acre",
        area: "Acreage",
        singular: "Acre",
        plural: "Acres",
        short: "ac"
    },
    {
        id: "hectare",
        area: "Hectarage",
        singular: "Hectare",
        plural: "Hectares",
        short: "ha"
    }
];

const SERVICE_QUANTITY_INFO = [
    ...QUANTITY_INFO.map(t => ({ id: t.id , singular: t.singular , plural: t.plural })),
    {
        id: "Bag",
        singular: "Bag",
        plural: "Bags"
    },
]

const DEFAULT_QUANTITY = QUANTITY_INFO.find(x => x.id === (process.env.REACT_APP_DEFAULT_QUANTITY || "acre") );

export const formatNumber = number => {
    return number.toLocaleString('en-us',{ maximumFractionDigits: 2 });
};

/**
 *
 * @return {{area: string, plural: string, short: string, id: string, singular: string}}
 */
export const getActiveQuantityInfo = () => DEFAULT_QUANTITY;

/**
 * Extract numeric quantity value from api payload
 * @param object
 * @param acre
 * @param hectare
 * @return {number}
 */
export const getQuantityValue = (object,{ acre, hectare }) => {

    const quantityInfo = getActiveQuantityInfo();
    let property = null;
    switch (quantityInfo.id) {
        case "acre":
            property = acre;
            break;
        case "hectare":
            property = hectare;
            break;
    }

    return Number(object[property]);
}

/**
 * Extracts quantity value and appends appropriate unit eg "2 acres", "3 hectares"
 * @param object
 * @param acre
 * @param hectare
 * @return {string}
 */
export const formatQuantity = (object, { acre , hectare }) => {
    const value = getQuantityValue(object, { acre , hectare });
    return `${formatNumber(value)} ${getQuantityUnit(value).toLowerCase()}`;
};

/**
 * Format quantity with short unit eg "2 ha", "12 ac"
 * @param object
 * @param acre
 * @param hectare
 * @return {string}
 */
export const formatQuantityShort = (object, { acre , hectare }) => {
    const quantityInfo = getActiveQuantityInfo();
    const value = getQuantityValue(object, { acre , hectare });
    return `${formatNumber(value)} ${quantityInfo.short}`;
}

/**
 * Formats quantity with given service object eg. "2 bags" , "2 hectares"
 * @param object
 * @param acre
 * @param hectare
 * @param service
 * @return {string}
 */
export const formatServiceQuantity = (object, { acre, hectare , service }) => {
    const value = getQuantityValue(object,{ acre , hectare });
    return `${formatNumber(value)} ${getServiceUnit(value, {service}).toLowerCase()}`;
}


/**
 * Gets the quantity unit for service eg. "Hectares", "Acres" , "Bag"
 * @param value
 * @param service
 * @return {*}
 */
export const getServiceUnit = (value,{ service }) => {
    const serviceInfo = SERVICE_QUANTITY_INFO.find(x => x.id.toLowerCase() === service.unit_name.toLowerCase());
    return (value === 1 ? serviceInfo.singular : serviceInfo.plural);
};

/**
 * Gets the quantity unit eg. "Hectares", "Acres"
 * @param value
 * @return {string}
 */
export const getQuantityUnit = (value) => {
    const quantityInfo = getActiveQuantityInfo();
    return value === 1 ? quantityInfo.singular : quantityInfo.plural;
}

/**
 * Returns the key with active quantity info eg. getQuantityKey({ acre: "propA" , hectare: "propB" }) => "propB"
 * @param acre
 * @param hectare
 * @return {*}
 */
export const getQuantityKey = ({ acre , hectare }) => {

    const quantityInfo = getActiveQuantityInfo();
    switch (quantityInfo.id) {
        case "acre":
            return acre;
        case "hectare":
            return hectare;
    }

};



// WEBPACK FOOTER //
// ./src/common/QuantityHelper.js